import { useAtomValue } from 'jotai';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { kpiPanelStructureIdOverride } from '../state';

/**
 * Resolves the structure id for the KPI panel flow. Prefers the override atom set by the
 * consumer (e.g. the platform page's KPI table which has no URL-level structure) and falls
 * back to the URL/global `useGetStructureId` otherwise.
 */
export const useKpiPanelStructureId = (): string => {
  const override = useAtomValue(kpiPanelStructureIdOverride);
  const fallback = useGetStructureId();
  return override || fallback;
};
